import React from 'react';
import { Table } from 'app-components';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

import Input from '@components/common/form/new/Input';
import { IEnrollmenFamilyMember } from '../common/types';
import { StyledTableSection, StyledTextCenter, StyledLabelNone } from './ModalStyles';

interface IMembersTableProps {
    data: IEnrollmenFamilyMember[];
    handleInputChange: (e: string, memberId: number) => void;
}

const MembersTable = ({ data, handleInputChange }: IMembersTableProps) => {
    const intl = useIntl();
    const columns = [
        {
            titleId: intl.formatMessage({ id: 'member.enrollment.modal.overrideEnrollmentStatus.tableHeader1' }),
            key: 'name',
            render: (row: IEnrollmenFamilyMember) => {
                return <span data-testid={`member-name-${row.memberId}`}>{row.name}</span>;
            },
        },
        {
            titleId: intl.formatMessage({ id: 'member.enrollment.modal.overrideEnrollmentStatus.tableHeader2' }),
            key: 'relationship',
            render: (row: IEnrollmenFamilyMember) => {
                return row.relationship === 'Self' ? (
                    <StyledTextCenter data-testid={`member-relationship-${row.memberId}`}>
                        <FontAwesomeIcon icon={faCheck} />
                    </StyledTextCenter>
                ) : (
                    <span data-testid={`member-relationship-${row.memberId}`}></span>
                );
            },
        },
        {
            titleId: intl.formatMessage({ id: 'member.enrollment.modal.overrideEnrollmentStatus.tableHeader3' }),
            key: 'memberId',
            render: (row: IEnrollmenFamilyMember) => {
                return (
                    <StyledLabelNone data-testid={`member-id-${row.memberId}`}>
                        <Input
                            label={{
                                labelText: 'member.enrollment.modal.textarea.placeholder',
                                labelClasses: [],
                                wrapperClasses: [''],
                                isRequired: false,
                            }}
                            input={{
                                id: 'issuerAssignedMemberId',
                                type: 'text',
                                isInputRequired: false,
                                value: row.issuerAssignedMemberId,
                            }}
                            actions={{
                                handleFieldChange: e => handleInputChange(e, row.memberId),
                            }}
                        />
                    </StyledLabelNone>
                );
            },
        },
    ];
    return (
        <StyledTableSection data-testid="members-table-section">
            <Table columns={columns} data={data} classNamesStr="enrollment_history" data-testid="members-table" />
        </StyledTableSection>
    );
};

export default MembersTable;
